export enum ReplotChartNames {
  BarChart = 'ReplotsBarChart',
  BoxPlot = 'ReplotsBoxPlot',
  GroupedBarChartHorizontal = 'ReplotsGroupedBarChartHorizontal',
  GroupedBarChartVertical = 'ReplotsGroupedBarChartVertical',
  DivergingBarChart = 'ReplotsDivergingBarChart',
  DivergingBarCombo = 'ReplotsDivergingBarCombo',
  KDE = 'ReplotsKDE', // DEPRECATED
  AreaChart = 'ReplotsAreaChart',
  LineChart = 'ReplotsLineChart',
  PieChart = 'ReplotsPieChart',
  Sankey = 'ReplotsSankeyChart',
  Chord = 'ReplotsChordChart',
  StackedBarChartHorizontal = 'ReplotsStackedBarChartHorizontal',
  StackedBarChartVertical = 'ReplotsStackedBarChartVertical',
  VolumeChart = 'ReplotsVolumeChart',
  TableChart = 'ReplotsTableChart',
  TreeMap = 'ReplotsTreeMap',
  IcicleChart = 'ReplotsIcicleChart',
  TimelineChart = 'ReplotsTimelineChart',
}

export const NEW_THEME_BAR_THICKNESS = 10;
export const NEW_THEME_BAR_GAP = 12;

/** How far past a bar's end (along the value axis) hover still resolves to it. */
export const BAR_END_HOVER_SLOP = 8;

export const CHART_HEADER_LABEL_HEIGHT = 20;
export const CHART_LABEL_GAP = 16;
